import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from "react";
import { DocumentAside } from "@components/document/document-aside";
import { DocumentLoginWrapper } from "@components/document/document-login-wrapper";
import { DocumentTitle } from "@components/document/document-title";
import { Separator } from "@components/ui/separator";
export const Document = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DocumentTitle />;
    t2 = <Separator />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DocumentAside />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <article data-slot="document" className="flex min-h-screen flex-1 flex-col pb-1">{t1}{t2}<div data-slot="document-body" className="flex min-h-screen flex-1 flex-col space-y-8 md:space-y-2 lg:flex-row lg:space-y-0 lg:space-x-12">{t3}<div data-slot="document-content" className="flex w-full flex-1 flex-col gap-4 p-2 md:p-4"><DocumentLoginWrapper>{children}</DocumentLoginWrapper></div></div></article>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};